export default "__VITE_ASSET__4f99d9b9__"